/*
 * Outbound and claim click events. Schema: docs/architecture.md 6.2 in the repo.
 * Plain JavaScript, no library, deferred. Nothing on the site needs it to work: the links
 * are ordinary links, this file only listens. It never calls preventDefault and never
 * delays navigation. If Shopify's analytics bus is missing, it quietly does nothing.
 *
 * Every value comes from data- attributes written by Liquid (snippets/dte-maker-link.liquid
 * and snippets/dte-maker-notices.liquid), never from user input. No full URL, query string
 * or personal data is sent: the destination is a hostname only.
 */
(function () {
  'use strict';

  function publish(name, data) {
    try {
      var bus = window.Shopify && window.Shopify.analytics;
      if (bus && typeof bus.publish === 'function') {
        bus.publish(name, data);
      }
    } catch (error) {
      /* measurement must never break a link */
    }
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: data }));
    } catch (error) {
      /* same */
    }
  }

  function onClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest('a[data-dte-outbound], a[data-dte-claim], a[data-dte-directions]');
    if (!link) return;
    var d = link.dataset;

    /* "Directions in Google Maps" on a trail-guide stop (snippets/dte-directions-link.liquid). Its own
       event, so maker click counts (dte:outbound_click) stay clicks to makers. */
    if ('dteDirections' in d) {
      publish('dte:directions_click', {
        link_position: d.linkPosition || '',
        stop_name: d.stop || '',
        maker_slug: d.makerSlug || '',
        page_type: d.pageType || 'page',
      });
      return;
    }

    if ('dteOutbound' in d) {
      publish('dte:outbound_click', {
        maker_slug: d.makerSlug || '',
        product_handle: d.productHandle || '',
        link_position: d.linkPosition || '',
        link_type: d.linkType || 'direct',
        destination_host: d.destinationHost || '',
        page_type: d.pageType || 'page',
      });
    } else {
      publish('dte:claim_click', {
        maker_slug: d.makerSlug || '',
        page_type: d.pageType || 'page',
      });
    }
  }

  /*
   * Email sign-up (dte:email_signup, form_location). A native Shopify form reloads the page, so the
   * form's place is remembered on submit and the event is published when the page comes back showing
   * the success message. Once per sign-up; the address itself is never read.
   */
  var SIGNUP_KEY = 'dte-signup-loc';
  document.addEventListener(
    'submit',
    function (event) {
      var wrap = event.target && event.target.closest && event.target.closest('[data-dte-signup]');
      if (!wrap) return;
      try {
        sessionStorage.setItem(SIGNUP_KEY, wrap.getAttribute('data-dte-signup') || '');
      } catch (error) {
        /* private mode: no event, the sign-up still works */
      }
    },
    true
  );
  try {
    var signupLoc = sessionStorage.getItem(SIGNUP_KEY);
    if (signupLoc !== null && document.querySelector('[data-dte-signup-ok]')) {
      sessionStorage.removeItem(SIGNUP_KEY);
      publish('dte:email_signup', { form_location: signupLoc });
    }
  } catch (error) {
    /* same */
  }

  document.addEventListener('click', onClick, { capture: true, passive: true });
  document.addEventListener('auxclick', onClick, { capture: true, passive: true });

  /*
   * Time on page (dte:engagement, msec). GA4 runs inside Shopify's pixel sandbox, which never sees the
   * real page become visible, so it records 0 s engagement for every visit. This counts only time the
   * page is visible, and hands it over in steps: every 10 s while visible, and whatever is left when the
   * page is hidden or closed. Stops after 10 minutes per page. A number only, nothing personal.
   */
  var STEP = 10000;
  var CAP = 600000;
  var sent = 0;
  var pending = 0;
  var since = document.visibilityState === 'visible' ? Date.now() : 0;

  function tick() {
    if (since) {
      var now = Date.now();
      pending += now - since;
      since = now;
    }
  }

  function flush(min) {
    tick();
    var ms = Math.min(pending, CAP - sent);
    if (ms < min) return;
    pending = 0;
    sent += ms;
    publish('dte:engagement', { msec: Math.round(ms) });
  }

  var timer = setInterval(function () {
    flush(STEP);
    if (sent >= CAP) clearInterval(timer);
  }, 5000);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flush(1000);
      since = 0;
    } else {
      since = Date.now();
    }
  });
  window.addEventListener('pagehide', function () {
    flush(1000);
    since = 0;
  });
})();
